import React, {useEffect, useState} from "react";
import { IPageResponse, SortDirection } from "common/interfaces/IPageResponse";
import { IPageRequest } from "common/interfaces/IPageRequest";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { ChargingReportsService } from "components/ChargingReports/ChargingReports.service";
import { ChargingReport, ChargingReportFilters, ChargingReportSortFields } from "components/ChargingReports/models";
import { ChargingReportsSearchBar } from "components/ChargingReports/ChargingReportsSearchBar";
import { ChargingReportsTable } from "components/ChargingReports/ChargingReportsTable";

interface ChargingReportsProps {
    onLoadValidatePage: () => void;
}

const searchApi = AwesomeDebouncePromise(
    request => ChargingReportsService.findChargingReports(request),
    300
);

const ChargingReports = (props : ChargingReportsProps ) => {
    const [chargingReports, setChargingReports] = useState<IPageResponse<ChargingReport>>();
    const [pageRequest, setPageRequest] = useState<IPageRequest<ChargingReportSortFields>>({
        page: 0,
        size: 20,
        sortDirection: SortDirection.ASC,
        sortField: ChargingReportSortFields.ID,
        searchQuery: null
    });
    
    const [filters, setFilters] = useState<ChargingReportFilters>({});
    const [isRequesting, setIsRequesting] = useState(false);
    const [loadingFileId, setLoadingFileId] = useState<number>();

    const searchChargingReports = (request: any, isInitial: boolean) => {
            if(isInitial) setIsRequesting(true);

            searchApi(request).then((response: IPageResponse<ChargingReport>) => {
                setChargingReports(response)
                setIsRequesting(false)
            })
    };

    const onPageChange = (targetPage: number) => {
        const page = targetPage - 1;
        setPageRequest({
            ...pageRequest,
            page
        })

        searchChargingReports({
            page,
            size: pageRequest.size,
            sortDirection: pageRequest.sortDirection,
            sortField: pageRequest.sortField,
            searchQuery: filters?.search
        }, false)
    };

    const handleSortClick = (sortField: ChargingReportSortFields) => {
            let sortDirection = SortDirection.ASC;
            if (pageRequest.sortField.match(sortField)) {
                sortDirection = pageRequest.sortDirection === SortDirection.DESC ? SortDirection.ASC : SortDirection.DESC;
            }

            setPageRequest({
                ...pageRequest,
                sortDirection,
                sortField
            })

            searchChargingReports({
                page: pageRequest.page,
                size: pageRequest.size,
                searchQuery: filters?.search,
                sortDirection,
                sortField,
            }, false)
    };

    const handleFilterChange = (change: ChargingReportFilters) => {
        setChargingReports(undefined);
        setPageRequest({
            ...pageRequest,
            page: 0
        })
        setFilters({
            ...filters,
            ...change
        })

        searchChargingReports({
            page: 0,
            size: pageRequest.size,
            sortDirection: pageRequest.sortDirection,
            sortField: pageRequest.sortField,
            searchQuery: change?.search
        }, false)
    };

    const initializeRequests = (isInitial: boolean) => {
        searchChargingReports({
            page: 0,
            size: pageRequest.size,
            sortDirection: pageRequest.sortDirection,
            sortField: pageRequest.sortField,
            searchQuery: filters?.search
        }, isInitial);
    }

    const getFile = async (chargingReportId: number) => {
        try {
            setLoadingFileId(chargingReportId);
            await ChargingReportsService.getChargingReportFile(chargingReportId)
        } catch(e) {
            console.error(e);
        } finally {
            setLoadingFileId(undefined)
        }
    }

    useEffect(() => {
        props.onLoadValidatePage();
        initializeRequests(true);
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <ChargingReportsSearchBar
                        onFilter={handleFilterChange} 
                        filters={filters}
                    />
                    <ChargingReportsTable 
                        onPageChange={onPageChange}
                        onSort={handleSortClick}
                        reports={chargingReports}
                        sortDirection={pageRequest.sortDirection}
                        sortField={pageRequest.sortField}
                        isRequesting={isRequesting}
                        getFile={getFile}
                        loadingFileId={loadingFileId}
                    />
                </div>
            </div>    
           
        </div>
    );
}

export default ChargingReports;